<template>
	<div :class="{ 'pt-safe-16': fixed }">
		<header
			class="viewport-max-width box-content flex h-16 items-center justify-center bg-white px-4 pt-safe text-center"
			:class="{ 'fixed top-0 right-0 left-0 z-100': fixed }"
		>
			<div class="flex basis-17 justify-start">
				<!-- Кнопка "Назад" -->
				<button
					v-if="showButtonBack"
					data-testid="header-btn-back"
					class="inline-flex h-6 w-6 shrink-0 items-center justify-center"
					@click="$emit('back')"
				>
					<img
						src="@/assets/icons/arrow-left.svg"
						alt=""
						width="24"
						height="24"
					/>
				</button>
			</div>

			<div class="absolute left-0 pl-4">
				<!-- @slot Идет перед заголовком -->
				<slot name="pre"></slot>
			</div>

			<!-- Заголовок -->
			<strong
				data-testid="header-title"
				class="font-sirius line-clamp-2 block w-full text-lg leading-none font-black"
			>
				{{ title }}
			</strong>

			<div class="flex basis-17 items-center justify-end">
				<UiBalance
					v-if="balanceAmount && isBalanceVisible"
					:amount="balanceAmount"
				/>

				<!-- Дополнительный контент -->
				<Component
					:is="node"
					v-for="(node, i) in headerVNodes"
					:key="i"
					class="vnodes"
				></Component>
			</div>
		</header>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import UiBalance from '@/components/ui/UiBalance.vue';
import { UserService } from '@/services/user';
import { useHeader } from '@/utils/composables';

interface Props {
	title?: string;
	fixed?: boolean;
	showButtonBack?: boolean;
}

withDefaults(defineProps<Props>(), {
	title: 'Рестораны',
	fixed: false,
	showButtonBack: true
});
defineEmits<{ (e: 'back'): void }>();

const { headerVNodes, isBalanceVisible } = useHeader();
const balanceAmount = computed(
	() => UserService.state.privateReward.balance || 0
);
</script>

<style>
.vnodes:not(:first-child) {
	margin-left: 0.5rem;
}
</style>
